/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import Theme from "../../../theme/theme";
import { StyledText } from "./styles";

export interface TextProps {
  fontSize?: "xSmall" | "small" | "normal" | "large";
  fontWeight?: "light" | "bolder" | "bold";
  fontStyle?: "normal" | "italic";
  color?: "primary" | "secondary";
}

export const Text: FunctionComponent<TextProps> = ({
  children,
  fontSize,
  fontWeight,
  fontStyle,
  color,
}) => (
  <Theme>
    <StyledText
      data-testid="text"
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      fontStyle={fontStyle}
    >
      {children}
    </StyledText>
  </Theme>
);

export default Text;
